function Card({ icon, text, onClick, isActive }) {
  return (
    <div className={`card ${isActive && "active"}`} onClick={onClick}>
      <div className="inner-items">
        {icon}
        <h3 className="m-0">{text}</h3>
      </div>
    </div>
  );
}

export default Card;
